/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Limits_DescriptionInputs */



/**
* | output |
* | --- |
* | "What every agent in the organization must stay within. A limit is checked when an agent is saved; agents saved earlier keep running until they are next changed." |
*
* @param {Agent_Policy_Limits_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_limits_description = /** @type {((inputs?: Agent_Policy_Limits_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Limits_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Woran sich jeder Agent der Organisation halten muss. Eine Grenze wird beim Speichern geprüft; früher gespeicherte Agenten laufen weiter, bis sie das nächste Mal geändert werden.")
	return /** @type {LocalizedString} */ ("What every agent in the organization must stay within. A limit is checked when an agent is saved; agents saved earlier keep running until they are next changed.")
});